import { pageQuery } from '../lib/egress.js';
import { openProgDrill } from './drills.js';

export async function renderProgrammes() {
  const el = document.getElementById('view-programmes');
  el.innerHTML = `
    <div class="page-header">
      <h1>Programmes</h1>
      <p>15 programmes; learner counts come from the v2 enrollments view.</p>
    </div>
    <div class="table-card">
      <table class="data-table">
        <thead><tr>
          <th>Programme</th>
          <th>Learners</th>
          <th>Created</th>
        </tr></thead>
        <tbody id="pr-tbody"><tr><td colspan="3" class="no-data">Loading…</td></tr></tbody>
      </table>
    </div>
  `;

  const [progs, byProg] = await Promise.all([
    pageQuery('programmes',              { order: 'programme_name', ascending: true }),
    pageQuery('learners_by_program_view'),
  ]);
  const counts = Object.fromEntries(byProg.data.map(r => [r.program_name, r.learner_count]));

  const tbody = document.getElementById('pr-tbody');
  tbody.innerHTML = progs.data.map(p => `
    <tr class="clickable-row" data-prog-id="${p.programme_id}" data-prog-name="${esc(p.programme_name)}">
      <td><strong>${esc(p.programme_name)}</strong></td>
      <td>${counts[p.programme_name] ?? 0}</td>
      <td>${p.created_at ? new Date(p.created_at).toLocaleDateString() : '—'}</td>
    </tr>
  `).join('');

  tbody.querySelectorAll('.clickable-row').forEach(row => {
    row.addEventListener('click', () => {
      openProgDrill({ programmeId: row.dataset.progId, programmeName: row.dataset.progName });
    });
  });
}

function esc(s) { return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c])); }
